export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "初始化錯誤",
    "StaticConfigLoader.caption.init": "初始化",
    "StaticConfigLoader.text.init": "初始化應用程式中……",
    "StaticConfigLoader.error.settings": "無法載入網站設定",
    "StaticConfigLoader.error.circuits": "無法載入服務配置",
    //app
    "Legal.Localization": "tw",
    "AchievementApp.Navbar.storeTitle": "商店",
    "AchievementApp.Navbar.supportTitle": "支持",
    "Legal.TermsConditions": "條款及條件",
    "Legal.TermsService": "服務條款",
    "Legal.PrivacyPolicy": "隱私權政策",
    "Legal.CookiesPolicy": "Cookie 設定",
    "Legal.Copyright": "所有商标，标识及品名均为其各自所有者的财产。",
    "AchievementApp.Navbar.achievement": "個人成就",
    "AchievementApp.Navbar.userAchievement": "使用者成就",
    "AchievementApp.Navbar.settingsLink": "設定",
    "AchievementApp.Navbar.profileLink": "設定檔",
    "AchievementApp.Navbar.reloginLink": "重新登入或變更帳戶",
    "AchievementApp.Navbar.pageTitlePrew": "",
    "AchievementApp.Navbar.pageTitle": "aijin.Net 成就",
    //commonAssets
    "ViewItemDetailed.state.completed": "已完成",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "按標題篩選",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "我的好友",
    "UserFriendsList.heading.showMore": "顯示更多",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "您需要配置雙因素認證",
    "LimitedAccountPanel.2step.link": "關於雙因素認證的更多資訊",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "您需要確認您的電子郵件地址",
    "LimitedAccountPanel.email.link": "前往設定檔",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "您的帳戶受到限制，因為：",
    "LimitedAccountPanel.conclusion": "變更安全設定後，應登出並重新登入使變更生效。",
    "LimitedAccountPanel.relogin": "重新登入",
    "EmailVerificationStateIcon.success": "已認證的帳戶，電子郵件已驗證",
    "EmailVerificationStateIcon.warning": "未認證的帳戶，電子郵件未驗證",
    "EmailVerificationStateIcon.danger": "未認證的帳戶，需要電子郵件驗證",
    "TwoFactorStateIcon.success": "以雙因素認證加強帳戶安全性",
    "TwoFactorStateIcon.warning": "不安全的帳戶，已停用雙因素認證",
    "TwoFactorStateIcon.danger": "需要雙因素認證",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "儲存設定",
    "UserSettingDialog.settings": "設定",
    "UserSettingDialog.userSettings": "使用者設定",
    "UserSettingDialog.language": "語言",
    "UserSettingDialog.privacy": "隱私",
    "UserSettingDialog.allUsers": "所有使用者",
    "UserSettingDialog.friendsOnly": "僅好友",
    "UserSettingDialog.onlyMe": "僅自己",
    "UserSettingDialog.whoCanView": "誰能查看我的成就",
    //unlockProgress
    "ViewUnlockProgress.of": " / ",
    "ViewUnlockProgress.achievCompleted": " 完成的成就",
    "ViewUnlockProgress.myUnlock": "我的成就",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "在此處搜尋暱稱",
    "ViewItemSearch.label.search": "搜尋使用者",
    "ViewItemSearch.resultNotFound": "未發現使用者",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "成就",
    "ViewItemSearch.stub.empty": "無成就",
    "ViewItemSearch.stub.emptyCompare_1": "使用者 ",
    "ViewItemSearch.stub.emptyCompare_2": " 此遊戲沒有成就",
    "ViewItemSearch.limitedAccess": "選擇的使用者的成就存取受限",
    "ViewItemSearch.heading.selectGame": "從清單中選擇遊戲",
    "ViewItemSearch.globalstat.opened": "解鎖人數：",
    "ViewItemSearch.globalstat.ofGamers": "% 遊戲玩家",
    //authentication
    "NotAllowedMessage.caption": "不允許",
    "NotAllowedMessage.body.h1": "成就存取",
    "NotAllowedMessage.body.h3": "您的帳戶目前不被允許",
    "NotAllowedMessage.relogin": "變更帳戶",
    "LandingMessage.caption": "驗證",
    "LandingMessage.body": "正在完成載入……",
    "TokenExpiredMessage.caption": "驗證已過期",
    "TokenExpiredMessage.body.h3": "我們對此能做的不多，但你還是可以",
    "TokenExpiredMessage.relogin": "重新登入",
    "AuthErrorMessage.caption": "驗證失敗",
    "AuthErrorMessage.body.h1": "無法檢查驗證",
    "AuthErrorMessage.body.code": "代碼",
    "AuthErrorMessage.body.desc": "我們對此能做的不多，但你還是可以",
    "AuthErrorMessage.relogin": "重新登入",
    "AuthorizationRequiredMessage.caption": "需要驗證",
    "AuthorizationRequiredMessage.body.h3.1": "您即將進入",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "但您需要獲得授權以繼續",
    "AuthorizationRequiredMessage.login": "登入 Gaijin.Net",
    "CheckingAuthMessage.caption": "驗證",
    "CheckingAuthMessage.body": "檢查身份驗證中，請耐心等待",
    "AuthorizationRequiredMessageMobile.body.h3.1": "行動版本暫時無法使用",
    "AuthorizationRequiredMessageMobile.body.h3.2": "請使用電腦版",
    "AuthorizationRequiredMessageMobile.body.h3.3": "我們為此道歉",
}